import { getUserRole, UserRole } from "@/entities/user";
import { AuthState } from "./authTypes";

export const selectIsAuthenticated = (state: { auth: AuthState }) =>
  state.auth.isAuthenticated;
export const selectCurrentUser = (state: { auth: AuthState }) =>
  state.auth.user;
export const selectAuthToken = (state: { auth: AuthState }) => state.auth.token;

// Пока бекенд не отдаёт роли текущего пользователя, сохраняем прежнее
// поведение админки: до появления роли «Учитель» в неё заходили только
// администраторы. Права всё равно проверяются на бекенде
export const selectCurrentRole = (state: { auth: AuthState }) =>
  state.auth.user?.roles?.length
    ? getUserRole(state.auth.user)
    : UserRole.ADMIN;
export const selectIsAdmin = (state: { auth: AuthState }) =>
  selectCurrentRole(state) === UserRole.ADMIN;
export const selectIsTeacher = (state: { auth: AuthState }) =>
  selectCurrentRole(state) === UserRole.TEACHER;
